export default {
	donations: {
		getValues: (orgID) => `/client/${orgID}/donation-presets`,
		processDonation: `/processdonation`,
		getCustomDonationFee: (orgID, amount) => `/client/${orgID}/donation-fee/${amount}`,
	},
}